import styles from "./Raport.module.scss";
import { useState } from "react";
import { FaCaretDown } from "react-icons/fa";
export default function Raport() {
  const [expanded, setExpanded] = useState(1);
  const handleChange = (event, id) => {
    setExpanded(event ? false : id);
  };
  return (
    <>
      <div className={styles.header}>Raport Sprzedaży</div>
      <div className={styles.tasksList}>
        <div
          className={
            expanded === 1
              ? `${styles.tasksRow} ${styles.expanded}`
              : `${styles.tasksRow}`
          }
          onClick={() => handleChange(expanded === 1, 1)}
        >
          <div className={styles.top}>
            <span>Sprzedaż netto</span>
            <FaCaretDown />
          </div>

          <div className={styles.accordion}>
            <div className={styles.row}>
              <span>Sprzedaż netto: </span>
              <span>100 zł</span>
            </div>
            <div className={styles.row}>
              <span>Sprzedaż netto YA: </span>
              <span>200 zł</span>
            </div>
            <div className={styles.row}>
              <span>Sprzedaż netto MA: </span>
              <span>300 zł</span>
            </div>
          </div>
        </div>
        <div
          className={
            expanded === 2
              ? `${styles.tasksRow} ${styles.expanded}`
              : `${styles.tasksRow}`
          }
          onClick={() => handleChange(expanded === 2, 2)}
        >
          <div className={styles.top}>
            <span>Marża</span>
            <FaCaretDown />
          </div>

          <div className={styles.accordion}>
            <div className={styles.row}>
              <span>Marża: </span>
              <span>100 zł</span>
            </div>
            <div className={styles.row}>
              <span>Marża YA: </span>
              <span>200 zł</span>
            </div>
            <div className={styles.row}>
              <span>Marża MA: </span>
              <span>300 zł</span>
            </div>
          </div>
        </div>
        <div
          className={
            expanded === 3
              ? `${styles.tasksRow} ${styles.expanded}`
              : `${styles.tasksRow}`
          }
          onClick={() => handleChange(expanded === 3, 3)}
        >
          <div className={styles.top}>
            <span>Marża %</span>
            <FaCaretDown />
          </div>

          <div className={styles.accordion}>
            <div className={styles.row}>
              <span>Marża %: </span>
              <span>100 %</span>
            </div>
            <div className={styles.row}>
              <span>Marża % YA: </span>
              <span>50 %</span>
            </div>
            <div className={styles.row}>
              <span>Marża % MA: </span>
              <span>25 %</span>
            </div>
          </div>
        </div>
        <div
          className={
            expanded === 4
              ? `${styles.tasksRow} ${styles.expanded}`
              : `${styles.tasksRow}`
          }
          onClick={() => handleChange(expanded === 4, 4)}
        >
          <div className={styles.top}>
            <span>Wyposażenie warsztatowe</span>
            <FaCaretDown />
          </div>

          <div className={styles.accordion}>
            <div className={styles.row}>
              <span>Sprzedaż WW: </span>
              <span>100 zł</span>
            </div>
            <div className={styles.row}>
              <span>Marża WW: </span>
              <span>200 zł</span>
            </div>
            <div className={styles.row}>
              <span>Marża % WW: </span>
              <span>75 %</span>
            </div>
          </div>
        </div>
        <div
          className={
            expanded === 5
              ? `${styles.tasksRow} ${styles.expanded}`
              : `${styles.tasksRow}`
          }
          onClick={() => handleChange(expanded === 5, 5)}
        >
          <div className={styles.top}>
            <span>Wzrost procentowy</span>
            <FaCaretDown />
          </div>

          <div className={styles.accordion}>
            <div className={styles.row}>
              <span>Sprz netto MA Dyn%: </span>
              <span>25 %</span>
            </div>
            <div className={styles.row}>
              <span>Sprz netto YA Dyn%: </span>
              <span>50 %</span>
            </div>
            <div className={styles.row}>
              <span>Sprz marża MA Dyn%: </span>
              <span>75 %</span>
            </div>
            <div className={styles.row}>
              <span>Sprz marża YA Dyn%: </span>
              <span>100 %</span>
            </div>
          </div>
        </div>
        <div className={styles.tasksRow}>
          <div className={styles.top}>
            <span>Przeterminowane płatności: 0 zł</span>
          </div>
        </div>
      </div>
    </>
  );
}
